import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { Background, ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.nav `
  --buttonFgColour: ${brand.global.white};

  &[data-variant=${ContentType.Savings}] {
    --buttonBgColour: ${brand.blue.default};
    --buttonBgColourDisabled: ${brand.blue.light};
    --buttonFgColourDisabled: ${brand.blue.default};

    [data-background=${Background.Blue}] & {
      --buttonBgColourDisabled: ${rgba(brand.blue.default, 0.15)};
    }
  }

  &[data-variant=${ContentType.Default}] {
    --buttonBgColour: ${brand.green.default};
    --buttonBgColourDisabled: ${brand.green.light};
    --buttonFgColourDisabled: ${brand.green.default};

    [data-background=${Background.Beige}] &,
    [data-background=${Background.Green}] & {
      --buttonBgColourDisabled: ${rgba(brand.green.default, 0.15)};
    }
  }

  &[data-variant=${ContentType.Intermediaries}] {
    --buttonFgColour: ${brand.blue.navy};
    --buttonBgColour: ${brand.green.light};
    --buttonBgColourDisabled: ${brand.global.white};
    --buttonFgColourDisabled: ${rgba(brand.blue.navy, 0.66)};

    [data-background=${Background.Beige}] &,
    [data-background=${Background.Green}] & {
      --buttonFgColour: ${brand.green.light};
      --buttonBgColour: ${brand.blue.navy};
    }
  }

  display: flex;
  align-items: center;
  column-gap: 8px;
`;
const Button = styled.button `
  ${ButtonReset};
  ${transition('opacity, color, background-color')};

  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: var(--buttonBgColour);
  border-radius: 100%;
  color: var(--buttonFgColour);

  &.focus-ring {
    outline: auto;
    outline-offset: 3px;
    outline-width: 2px;
    outline-color: var(--buttonBgColour);
  }

  &.focus-ring,
  &:hover,
  &:active {
    opacity: 0.65;
  }

  &:disabled {
    background-color: var(--buttonBgColourDisabled);
    color: var(--buttonFgColourDisabled);
    opacity: 1;
    cursor: not-allowed;
  }

  svg {
    display: block;
    width: 24px;
  }

  &[data-prev] svg {
    transform: scale(-1);
  }
`;
const ControlsStyles = {
    Container,
    Button,
};
export default ControlsStyles;
